import styled from "@emotion/styled";
import {ReactNode} from "react";

const Box = styled.div`
    margin: 20px 0;
`;


interface Props {
    children?: ReactNode;
}

export default function Footer({children}: Props) {
    return (
        <Box>{children}</Box>
    );
}
